module.exports = __webpack_public_path__ + "static/media/files-icon.adf945a2.png";